import React from 'react'
import { displayStringForPriceRangeWithoutCurrency } from '../../helpers/product-price'
import { IProductPrices, IIssue } from '../../types'
import AnalyticsDataWrapper from '../analytics-data-wrapper'
import ProductCard from '../product-card'
import {
  discountedPriceRange,
  priceRange,
  discountPercentageRange,
} from '../../helpers/price-ranges'
import style from './index.module.scss'

export interface IVariant {
  sku: string
  price?: IProductPrices
  onSale: boolean
}

export interface IProduct {
  variantGroupCode: string
  name: string
  brand: { name: string; slug: string } | undefined
  category?: string[]
  shop: {
    id: number
    name: string
    retailer?: {
      title: string
      sys: {
        id: string
      }
    }
  }
  image?: string
  variant?: IVariant
  otherVariants: IVariant[]
  issues?: IIssue[]
}

interface IProductListAnalytics {
  productList?: string
}
interface IProductsListProps {
  products: IProduct[]
  page: number
  itemsPerPage: number
  basePath?: string
  analytics?: IProductListAnalytics
}

const ProductsList: React.FunctionComponent<IProductsListProps> = ({
  products,
  page,
  itemsPerPage,
  analytics,
}) =>
  products.length === 0 ? null : (
    <div className={style.productsListGrid}>
      {products.map((product, index) => {
        const price = discountedPriceRange(product) ?? priceRange(product)
        const trackable = {
          'data-ecomm-product': 'product',
          'data-product-brand': product.brand?.name ?? '',
          'data-product-retailer': product.shop.name,
          'data-product-retailer-id': product.shop.retailer?.sys.id ?? '',
          'data-product-category':
            product.category?.[product.category.length - 1] ?? '',
          'data-product-id': product.variantGroupCode,
          'data-product-name': product.name,
          'data-product-price': displayStringForPriceRangeWithoutCurrency(
            price
          ),
          'data-product-list': analytics?.productList ?? 'product list',
          'data-product-variant': '',
          'data-product-currency': 'AUD',
          'data-product-position': itemsPerPage * page + (index + 1),
        }

        return (
          <AnalyticsDataWrapper
            key={[product.variantGroupCode, product.shop.id].join('/')}
            {...trackable}
          >
            <ProductCard
              product={product}
              shop={product.shop}
              priceRange={priceRange(product)}
              discountedPriceRange={discountedPriceRange(product)}
              discountPercentageRange={discountPercentageRange(product)}
            />
          </AnalyticsDataWrapper>
        )
      })}
    </div>
  )

export default ProductsList
